import { Component, Vue, Prop } from "vue-facing-decorator";
import type { MessageStructureComponent, MessageContentSettings } from "../types";
import { ActionHandler } from "../helpers/action_handler";
import { __vueEvent } from "../constant";
import { isFirefox } from '../helpers/get-browser-type';
import { isSvgImage } from '../helpers/get-image-type-from-url';

@Component
export default class Img extends Vue {
    //#region Component Props

    @Prop() component?: MessageStructureComponent;
    @Prop({
      type: Object,
      default() {
        return {};
      },
    })
    structureSettings?: any;
    
    @Prop({ type: [String, Number] })
    messageId!: string | number;
    //#endregion

    //#region Computed Properties

    get prefixClassName() {
      return this.$store.state.prefixClassName || "";
    }
    get enableMessageNavigation() {
      return this.$store.state.enableMessageNavigation || false;
    }

    //#endregion

    onElClick() {
      
       let isClicked = true;
      try	{
				if (
				this.structureSettings != null &&
				Object.keys(this.structureSettings).length !== 0 &&
				typeof this.structureSettings.hideNavigationImageOnSend !== "undefined"
			) {
				isClicked = this.structureSettings.hideNavigationImageOnSend;
			}
			} catch(ex){}
       this.component.messageId = this.messageId;
        ActionHandler.handleBtnClickAction(this.component, {}, isClicked);
    }

    /**
     * JIRA: SD-5252
     * Checks if the current browser is Firefox and the component's image URL is an SVG image.
     * @returns {boolean} True if the browser is Firefox and the image URL is an SVG image, false otherwise.
     */
    get isFirefoxSVGClass(): boolean {
      try {
        return this.component && isFirefox() && isSvgImage(this.component.imageUrl || '');
      } catch (ex) {
        return false;
      }
    }
}
